import {aesDecrypt, aesEncrypt, getQueryParams} from '@/utils/hooks/index.js'
import axios from 'axios'
import {baseUrl} from "./api"
import {changeURLArg, regExpQuery} from './webUtil'
// import { storage } from "@/utils/hooks/index"
import {loginOut} from '@/api/login'
import router from '@/router/index'
import store from '@/store/index'
import {aesDeciphering} from "@/utils/hooks/aesDeciphering";

axios.defaults.baseURL = baseUrl
const service = axios.create({
    // withCredentials: true, // send cookies when cross-domain requests
    //crossDomain: true, // 设置跨域为true
    timeout: 60000, // request timeout
})

//请求白名单不携带token
const whiteUrl = ['https://api-v3.speedtest.cn/ip', 'https://api-v3-test.speedtest.cn/ip', 'https://api-v3-pre.speedtest.cn/ip', '/v1/login']
// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []


service.interceptors.request.use(
    config => {
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // config.headers['Access-Control-Allow-Origin'] = '*';
        let currentRoute = router.app.$route.meta
        // 每次发送请求之前都检测vuex是否存有token,放在请求头发送给服务器
        // Authorization是根据后端自定义字段
        const noToken = config.headers['No-Token'] == 1
        const isWhiteUrl = whiteUrl.includes(config.url)
        if (!isWhiteUrl) {
            config.headers.key = 'CRYPTO_VERSION'
            config.headers.value = '1.0.3'
        }
        if (store.getters['login/getToken'] && store.getters['login/getTokenType'] && store.getters['login/getIsLogin'] && !noToken && !isWhiteUrl) {
            config.headers.Authorization = store.getters['login/getTokenType'] + ' ' + store.getters['login/getToken']
        }
        if (config.params && config.params.province) {
            switch (config.params.province) {
                case '中国新疆':
                    config.params.province = '新疆'
                    break
                case '中国西藏':
                    config.params.province = '西藏'
                    break
                case '中国台湾':
                    config.params.province = '台湾'
                    break
                case '中国澳门':
                    config.params.province = '澳门'
                    break
                case '中国香港':
                    config.params.province = '香港'
                    break
                default:
                    break
            }
        }
        if (config.url) {
            let province = regExpQuery(config.url, 'province')
            if (province) {
                switch (province) {
                    case '中国新疆':
                        config.url = changeURLArg(config.url, 'province', '新疆')
                        break
                    case '中国西藏':
                        config.url = changeURLArg(config.url, 'province', '西藏')
                        break
                    case '中国台湾':
                        config.url = changeURLArg(config.url, 'province', '台湾')
                        break
                    case '中国澳门':
                        config.url = changeURLArg(config.url, 'province', '澳门')
                        break
                    case '中国香港':
                        config.url = changeURLArg(config.url, 'province', '香港')
                        break
                    default:
                        break
                }
            }
            //通过封装方法将直接拼接参数的url 中的参数拆分到params
            if (!config.params) {
                config.params = getQueryParams(config.url)
                config.url = config.url.split('?')[0]
            }
        }
        //二级页面统一增加参数
        if (config.params && currentRoute && currentRoute.isChildren && !config.url.includes('logout')) {
            config.params.isMemberData = 1
        }
        //二级页面统一增加参数
        if ((!config.params) && config.url && currentRoute && currentRoute.isChildren && !config.url.includes('logout')) {
            config.url = config.url + '&isMemberData=1'
        }
        if (config.method === "get") {
            //axios get请求设置请求头Content-Type不生效，失败
            //如果请求方式是get   则给data赋值，躲过if判断，就不会被删除，这样就可以了
            config.data = true
            // for (let key in config.params) {
            //   config.params[key] = aesEncrypt(config.params[key])
            // }
            if (config.params && (!config.params.cryptoParam)) {
                let obj = {cryptoParam: aesEncrypt(config.params)}
                config.params = obj
            }
        }
        if (config.method === "post" || config.method === "put") {
            if (config.data && (!config.data.cryptoParam)) {
                let obj = {cryptoParam: aesEncrypt(config.data)}
                config.data = obj
            }
        }

        if (config.method === "delete") {
            if (config.data && (!config.url.includes('cryptoParam'))) {
                let obj = `cryptoParam=${aesEncrypt(config.data)}`
                config.data = null
                config.url = config.url + `?${obj}`
            }
        }
        return config
    },
    error => {
        // do something with request error
        //console.log(error);// for debug
        return Promise.reject(error)
    }
)


service.interceptors.response.use(
    response => {
        // 在status正确的情况下，code不正确则返回对应的错误信息（后台自定义为200是正确，并且将错误信息写在message），正确则返回响应
        //return response.data.code == 202 || response.data.code == 200 || response.data.code == 0 ? (response.data ? response.data : response) : Promise.reject(response.data ? response.data : response)
        //return response.data
        if (response.data && response.data.cryptoParam) {
            response.data = aesDecrypt(response.data.cryptoParam)
        }
        // 如果参数需要解密，则进行解密
        if (response.data.data && response.config.hasAesDecipher) {
            response.data.data = aesDecrypt(response.data.data,1);
        }
        let statusCode = response.data.code
        switch (statusCode) {
            case 202:
                return response.data ? response.data : response
            case 200:
                return response.data ? response.data : response
            case 0:
                return response.data ? response.data : response
            case 401:
                //后端请求拦截了 状态码改成401
                const config = response.config
                if (!isRefreshing) {
                    //第一个接口过来发现access_token过期
                    isRefreshing = true //正在刷新状态
                    return refreshToken().then(res => {
                        //刷新token信息
                        store.commit('login/setValue', [res.access_token, 'access_token'])
                        store.commit('login/setValue', [res.refresh_token, 'refresh_token'])
                        store.commit('login/setValue', [res.token_type, 'token_type'])
                        store.commit('login/setValue', [true, 'is_login'])
                        store.commit('login/setValue', [res, 'userInfor'])
                        if (store.getters['login/getToken'] && store.getters['login/getTokenType']) {
                            config.headers.Authorization = store.getters['login/getTokenType'] + ' ' + store.getters['login/getToken']
                        }
                        // 已经刷新了token，将所有队列中的请求进行重试
                        requests.forEach(cb => cb())
                        requests = []
                        return service(config)
                    }).catch(res => {
                        console.error('refreshtoken error =>', res)
                        //refresh_token过期，清除它
                        loginOut({apiVersion: 'v1'})
                            .then(res => {
                                console.log(177, res)
                            })
                            .catch(err => {
                                console.log(180, err)
                            })
                            .finally(() => {
                                store.commit('login/delValue', 'access_token')
                                store.commit('login/delValue', 'refresh_token')
                                store.commit('login/delValue', 'token_type')
                                store.commit('login/delValue', 'is_login')
                                store.commit('login/delValue', 'is_member')
                                store.commit('login/delValue', 'effect_end_date')
                                store.commit('login/delValue', 'userInfor')
                                store.commit('login/delValue', 'backUrl')
                                let currentRoute = router.app.$route.path
                                const whiteList = ['/', '/realtime', '/operators', '/ranks', '/map/speed', '/map/signal', '/back-password']
                                if (whiteList.includes(currentRoute)) {
                                    sessionStorage.setItem('loginAlertShow', true)
                                    location.href = location.href
                                } else {
                                    sessionStorage.setItem('loginAlertShow', true)
                                    location.href = '/'
                                }
                            })
                    }).finally(() => {
                        isRefreshing = false
                    })
                } else {
                    // 正在刷新token，将返回一个未执行resolve的promise
                    return new Promise((resolve) => {
                        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                        requests.push(() => {
                            if (store.getters['login/getToken'] && store.getters['login/getTokenType'] && store.getters['login/getIsLogin']) {
                                config.headers.Authorization = store.getters['login/getTokenType'] + ' ' + store.getters['login/getToken']
                            }
                            resolve(service(config))
                        })
                    })
                }
            case 1001:
                //会员状态过期
                store.commit("login/delValue", 'is_member')
                store.commit("login/delValue", 'effect_end_date')
                location.href = '/'
                break
            default:
                //状态码400代表刷新token也过期
                //console.log(response.data ? response.data : response)
                return Promise.reject(response.data ? response.data : response)
        }
    },
    error => {
        // 在status不正确的情况下，判别status状态码给出对应响应
        if (error.response) {
            console.log("在respone拦截器显示错误：", error.response)
            switch (error.response.status) {
                // case 401:
                //   //access_token过期
                //   //store.commit("login/delValue", 'access_token')
                //   const config = error.response.config
                //   if (!isRefreshing) {
                //     //第一个接口过来发现access_token过期
                //     isRefreshing = true //正在刷新状态
                //     return refreshToken().then(res => {
                //       //刷新token信息
                //       store.commit('login/setValue', [res.access_token, 'access_token'])
                //       store.commit('login/setValue', [res.refresh_token, 'refresh_token'])
                //       store.commit('login/setValue', [res.token_type, 'token_type'])
                //       store.commit('login/setValue', [true, 'is_login'])
                //       store.commit('login/setValue', [res, 'userInfor'])
                //       if (store.getters['login/getToken'] && store.getters['login/getTokenType']) {
                //         config.headers.Authorization = store.getters['login/getTokenType'] + ' ' + store.getters['login/getToken']
                //       }
                //       // 已经刷新了token，将所有队列中的请求进行重试
                //       requests.forEach(cb => cb())
                //       requests = []
                //       return service(config)
                //     }).catch(res => {
                //       console.error('refreshtoken error =>', res)
                //       //refresh_token过期，清除它
                //       store.commit("login/delValue", 'access_token')
                //       store.commit("login/delValue", 'refresh_token')
                //       store.commit("login/delValue", 'token_type')
                //       store.commit("login/delValue", 'is_login')
                //       store.commit("login/delValue", 'userInfor')
                //       store.commit("login/delValue", 'backUrl')
                //       let currentRoute = router.app.$route.path
                //       const whiteList = ['/', '/realtime', '/operators', '/ranks', '/map/speed', '/map/signal', '/back-password']
                //       if (whiteList.includes(currentRoute)) {
                //         sessionStorage.setItem('loginAlertShow', true)
                //         location.href = location.href
                //       } else {
                //         sessionStorage.setItem('loginAlertShow', true)
                //         location.href = '/'
                //       }
                //     }).finally(() => {
                //       isRefreshing = false
                //     })
                //   } else {
                //     // 正在刷新token，将返回一个未执行resolve的promise
                //     return new Promise((resolve) => {
                //       // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                //       requests.push(() => {
                //         if (store.getters['login/getToken'] && store.getters['login/getTokenType'] && store.getters['login/getIsLogin']) {
                //           config.headers.Authorization = store.getters['login/getTokenType'] + ' ' + store.getters['login/getToken']
                //         }
                //         resolve(service(config))
                //       })
                //     })
                //   }
                //break
            }
        }
        return Promise.reject(error)
    }
)

function refreshToken() {
    let data = {
        grantType: 'refresh_token',
        refreshToken: store.getters['login/getRefreshToken'],
        clientId: '1',
        clientSecret: '123456',
    }
    // instance是当前request.js中已创建的axios实例
    return service.post('/v1/login', data).then(res => res.data)
}

export default service

